import { BarChart2, Users, MapPin, FlaskConical } from "lucide-react";

const StatsCards = ({ totalArea, totalFarmers, uniqueVillages, chemicalUsed }) => {
  const stats = [
    {
      title: "Total Spraying Area",
      value: totalArea.toFixed(1) + ' acres',
      icon: <BarChart2 className="text-yellow-300 w-7 h-7" />,
      bg: "from-yellow-400 to-yellow-600",
    },
    {
      title: "Total Farmers Enrolled",
      value: totalFarmers,
      icon: <Users className="text-green-300 w-7 h-7" />,
      bg: "from-green-400 to-green-600",
    },
    {
      title: "Villages Covered",
      value: uniqueVillages,
      icon: <MapPin className="text-blue-300 w-7 h-7" />,
      bg: "from-blue-400 to-blue-600",
    },
    {
      title: "Liquid Chemicals Used",
      value: '110.51 L',
      icon: <FlaskConical className="text-pink-300 w-7 h-7" />,
      bg: "from-pink-400 to-pink-600",
    },
    {
      title: "Granular & Powder Chemicals Used",
      value: '48.66 Kg',
      icon: <FlaskConical className="text-pink-300 w-7 h-7" />,
      bg: "from-pink-400 to-pink-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5">
      {stats.map((stat, idx) => (
        <div
          key={idx}
          className="rounded-2xl bg-white shadow-xl shadow-white/5 p-5 transition-transform hover:scale-105"
        >
          <div className="flex items-center gap-6">
            <div
              className={`p-3 rounded-full bg-gradient-to-br ${stat.bg} shadow-md shadow-black/20`}
            >
              {stat.icon}
            </div>
            <div>
              <h4 className="text-sm text-black">{stat.title}</h4>
              <p className="text-2xl text-black font-bold mt-1">{stat.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
